module.exports = __webpack_public_path__ + "img/mq_4.4f685219.svg";